export class MatchingPropertyField {

  static readonly MATCHING_PROPERTY_ID = 'matchingPropertyId';
  static readonly VENDOR_SOURCE = 'vendorSource';
  static readonly CREATED_DATE = 'createdDate';

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-property-field.ts